// スタイルを追加
const style = document.createElement("style");
style.textContent = `
    #uniweb--sdk-root {
        opacity: 0 !important;
    }
    #uniweb--sdk-root.is-ready {
        opacity: 1 !important;
    }
`;
document.head.appendChild(style);

class ShadowDOMButtonRemover {
  constructor() {
    this.attempts = 0;
    this.maxAttempts = 50;
    this.interval = null;
    this.init();
  }

  init() {
    this.interval = setInterval(() => {
      this.findAndProcessButton();
      this.attempts++;

      if (this.attempts >= this.maxAttempts) {
        clearInterval(this.interval);
        this.markAsReady();
      }
    }, 100);

    this.setupObserver();
  }

  findAndProcessButton() {
    const allElements = document.querySelectorAll("*");
    let buttonFound = false;

    allElements.forEach((element) => {
      if (element.shadowRoot) {
        if (this.processShadowRoot(element.shadowRoot)) {
          buttonFound = true;
        }
      }

      if (
        element.getAttribute("aria-label") ===
        "ウェブアクセシビリティ機能を表示する"
      ) {
        this.hideElement(element);
        buttonFound = true;
      }
    });

    if (buttonFound) {
      this.markAsReady();
      clearInterval(this.interval);
    }
  }

  processShadowRoot(shadowRoot) {
    let buttonFound = false;
    const button = shadowRoot.querySelector(
      'button[aria-label="ウェブアクセシビリティ機能を表示する"]'
    );
    if (button) {
      this.hideElement(button);
      buttonFound = true;
    }

    shadowRoot.querySelectorAll("*").forEach((element) => {
      if (element.shadowRoot) {
        if (this.processShadowRoot(element.shadowRoot)) {
          buttonFound = true;
        }
      }
    });

    return buttonFound;
  }

  hideElement(element) {
    try {
      element.style.cssText = `
                display: none !important;
                visibility: hidden !important;
                opacity: 0 !important;
                pointer-events: none !important;
                position: absolute !important;
                width: 1px !important;
                height: 1px !important;
                margin: -1px !important;
                padding: 0 !important;
                overflow: hidden !important;
                clip: rect(0, 0, 0, 0) !important;
                white-space: nowrap !important;
                border: 0 !important;
            `;
      element.setAttribute("hidden", "true");
      element.setAttribute("aria-hidden", "true");
    } catch (error) {
      console.error("ボタンの非表示化に失敗:", error);
    }
  }

  markAsReady() {
    const sdkRoot = document.querySelector("#uniweb--sdk-root");
    if (sdkRoot) {
      sdkRoot.classList.add("is-ready");
    }
  }

  setupObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.shadowRoot) {
              this.processShadowRoot(node.shadowRoot);
            }
            if (
              node.getAttribute("aria-label") ===
              "ウェブアクセシビリティ機能を表示する"
            ) {
              this.hideElement(node);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });
  }
}

// インスタンスを作成して実行
const buttonRemover = new ShadowDOMButtonRemover();

// ページロード完了時の処理
window.addEventListener("load", () => {
  buttonRemover.findAndProcessButton();
});
